export default {
  actions: {
    createLevel({ dispatch }, level) {
      this.$authorize('edit', 'Qualification')

      return Vue.$http.post(`admin/qualifications/${level.qualification.id}/levels`, { level }).then(
        () => dispatch('fetch', level.qualification.id)
      )
    },
    removeLevel({ dispatch }, level) {
      this.$authorize('edit', 'Qualification')

      return Vue.$http.delete(`admin/qualifications/${level.qualification.id}/levels/${level.id}`).then(
        () => dispatch('fetch', level.qualification.id)
      )
    },
    updateLevel({ dispatch }, level) {
      this.$authorize('edit', 'Qualification')

      return Vue.$http.patch(`admin/qualifications/${level.qualification.id}/levels/${level.id}`, { level }).then(
        () => dispatch('fetch', level.qualification.id)
      )
    }
  }
}
